import { browserSafeFonts, googleFonts } from "components/WebDesigner/StyleInputs/FontField";
import { useRef } from "react"



const allFonts = [...googleFonts,...browserSafeFonts]

async function GenerateAll(canvas:HTMLCanvasElement){

    let ctx = canvas.getContext('2d');
    if(!ctx)
        return;

    for(let i = 0;i<allFonts.length;i++){
        let fontName = allFonts[i].replaceAll(" ","-").toLowerCase();
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        drawHeading(canvas,allFonts[i]);
        await sleep(100);
        downloadImage(canvas,"heading-"+fontName+".png");
        await sleep(600);
    }


    // for(let i = 0;i<allFonts.length;i++){
    //     let fontName = allFonts[i].replaceAll(" ","-").toLowerCase();
    //     ctx.clearRect(0, 0, canvas.width, canvas.height);
    //     drawParagraph(canvas,allFonts[i]);
    //     await sleep(100);
    //     downloadImage(canvas,"paragraph-"+fontName+".png");
    //     await sleep(600);
    // }

}

function downloadImage(canvas:HTMLCanvasElement, filename:string) {
var dataURL = canvas.toDataURL('image/png');

  // Create temporary anchor element
  var link = document.createElement('a');
  link.href = dataURL;
  link.download = filename;

  // Trigger a click event to initiate download
  link.click();

}


function sleep(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  

// function GenrerateAtIndex(canvas:HTMLCanvasElement,index:number){

   
//     let font = allFonts[index%allFonts.length];
//     console.log(font);
//     let ctx = canvas.getContext('2d');
//     if(!ctx)
//         return;

//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     if(index%2===0)
//     drawParagraph(canvas,font);
//     else
//     drawHeading(canvas,font);
//     // if(index<200)
//     // setTimeout(() => {
//     //     GenrerateAtIndex(canvas,index+1);

//     // },500);
// }


// const paragraphLineOne = "Lorem ipsum dolor sit amet, consectetur adipiscing elit.";   
// const paragraphLineTwo = "Quisque odio idam, feugiat sit amet mi vitae"; 

// const drawParagraph = (canvas:HTMLCanvasElement,fontFamily:string,fontSize:number = 16)=>{
//     let ctx = canvas.getContext('2d');

//     if(!ctx)
//         return;
    
//     ctx.fillStyle = 'white'; // Set the text color
//     let top = canvas.height/2 - fontSize/4;
//     ctx.font = `${fontSize}px `+fontFamily; // Set the font size and type
//     ctx.textAlign = 'center'; // Set text alignment

//     let maxWidth = ctx.measureText(paragraphLineOne).width;
//     if(maxWidth>canvas.width*.9){//greater than 90% of the canvas width
//         console.log("ALERT")
        
//         drawParagraph(canvas,fontFamily,fontSize-1);
//         return;
//     }

//     ctx.fillText(paragraphLineOne,canvas.width/2, top); // Position text in the center
//     ctx.fillText(paragraphLineTwo,canvas.width/2, top+fontSize*1.2); 
// }

const drawHeading = (canvas:HTMLCanvasElement,fontFamily:string,fontSize:number = 42)=>{
    let ctx = canvas.getContext('2d');

    if(!ctx)
        return;
    ctx.fillStyle = 'white'; // Set the text color
    let top = canvas.height/2 +fontSize/4;
    ctx.font = `500 ${fontSize}px `+fontFamily; // Set the font size and type
    ctx.textAlign = 'center'; // Set text alignment
    ctx.fillText("Headline Goes Here",canvas.width/2, top); // Position text in the center

}

export function LoadAllGoogleFonts(){
return <>
    
    { googleFonts.map(
        (font,i:number)=>{
            let formatted = font.replaceAll(" ","+");
            return <link key = {font+i.toString()} href={`https://fonts.googleapis.com/css2?family=${formatted}`} rel="stylesheet" />;
          
        })

        

    }
    {
        googleFonts.map(


            (font,i:number)=>{
            
                return <span style={{fontFamily:font,fontSize:"1px"}}  key = {font+i.toString()}>{font}</span>;
              
            }
        )
    }
    </>
}

export default function FontGenerator(){

    const cavasRef = useRef<HTMLCanvasElement>(null);



    return <>
    <LoadAllGoogleFonts/>
    <canvas width={512} height={128} ref={cavasRef} style={{border:"1px solid grey",margin:"0px 16px",background:"grey"}}></canvas>

    <button onClick = {()=>{cavasRef.current&& GenerateAll(cavasRef.current)}} >Generate</button>

    </>





}